'use strict';

require("core-js/modules/es.array.reduce");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = initApiMethods;

var _schema = require('../lib/schema');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function initApiMethods(fetch, store, getRouteConfig) {
  // TODO: use some more specific method from store's undo implementation
  var isUndo = function isUndo() {
    return store._getState('_reset');
  };

  var shouldFetch = function shouldFetch(path) {
    return !isUndo() && !store.getPending(path) && !store.getError(path);
  };

  var api = ['get', 'post', 'put', 'delete'].reduce(function (memo, method) {
    return _extends({}, memo, _defineProperty({}, method, function (path) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      store.setPending(path, true);
      return fetch[method].apply(fetch, [path].concat(args)).then(function (response) {
        store.setPending(path, false);
        store.setError(path, null, {
          quiet: true
        });
        return response;
      }, function (err) {
        store.setPending(path, false);
        store.setError(path, err);
        return Promise.reject(err);
      });
    }));
  }, {});

  var methods = _extends({
    fetchAll: function fetchAll(path) {
      var _getRouteConfig = getRouteConfig('list'),
          defaultRoute = _getRouteConfig.route,
          method = _getRouteConfig.method,
          onSuccess = _getRouteConfig.onSuccess,
          onError = _getRouteConfig.onError;

      var route = path || defaultRoute;

      if (shouldFetch(route)) {
        var promise = api[method](route);
        store.setRequestsPromise(route, promise);
        return promise.then(onSuccess).then(function (response) {
          store.setCollection(response, route);
          return response;
        }).catch(onError);
      } else {
        return store.getRequestsPromise(route);
      }
    },
    fetchOne: function fetchOne(id) {
      var _getRouteConfig2 = getRouteConfig('get', id),
          route = _getRouteConfig2.route,
          method = _getRouteConfig2.method,
          onSuccess = _getRouteConfig2.onSuccess,
          onError = _getRouteConfig2.onError;

      if (shouldFetch(route)) {
        var promise = api[method](route);
        store.setRequestsPromise(route, promise);
        return promise.then(onSuccess).then(function (response) {
          store.setModel((0, _schema.getIdFromModel)(response), _extends({}, response, {
            _fetched: true
          }));
          return response;
        }).catch(onError);
      } else {
        return store.getRequestsPromise(route);
      }
    },
    createOne: function createOne(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _getRouteConfig3 = getRouteConfig('create', data),
          route = _getRouteConfig3.route,
          method = _getRouteConfig3.method,
          onSuccess = _getRouteConfig3.onSuccess,
          onError = _getRouteConfig3.onError;

      var promise = api[method](route, data);
      store.setRequestsPromise(route, promise);
      return promise.then(onSuccess).then(function (data) {
        if (options.refetch !== false) {
          methods.fetchAll();
        } else {
          store.updateCollection(data);
        }

        return data;
      }).catch(onError);
    },
    updateOne: function updateOne(id, data) {
      var _getRouteConfig4 = getRouteConfig('update', id, data),
          route = _getRouteConfig4.route,
          method = _getRouteConfig4.method,
          onSuccess = _getRouteConfig4.onSuccess,
          onError = _getRouteConfig4.onError;

      var promise = api[method](route, data);
      store.setRequestsPromise(route, promise);
      return promise.then(onSuccess, onError);
    },
    deleteOne: function deleteOne(id) {
      var _getRouteConfig5 = getRouteConfig('delete', id),
          route = _getRouteConfig5.route,
          method = _getRouteConfig5.method,
          onSuccess = _getRouteConfig5.onSuccess,
          onError = _getRouteConfig5.onError;

      var promise = api[method](route);
      store.setRequestsPromise(route, promise);
      return promise.then(onSuccess, onError);
    },
    custom: function custom(config) {
      var promise = api[config.method](config.route, config.body);
      store.setRequestsPromise(config.route, promise);
      return promise.then(config.onSuccess).then(function (response) {
        store.setRequestsData(config.route, response);
        return response;
      }).catch(config.onError);
    },
    shouldFetch: shouldFetch
  }, api);

  return methods;
}